
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/restaurants/[state]",
      function () {
        return require("private-next-pages/restaurants/[state]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/restaurants/[state]"])
      });
    }
  